import React from 'react'
import "./styles.scss"
import { ListOfLocationsToAnalyst } from 'src/stateManagement/redux/slices/gerencia_tecnica/interfaces'
import ButtonCircle from '../../../shared/components/button_circle';

export interface ModalAnalystProps {
    onClose: () => void;
    location: ListOfLocationsToAnalyst;
}

export const ModalAnalyst = (prop: ModalAnalystProps) => {
    const { onClose, location } = prop;

    return (
        <div className="analyst_modal_container">
            <div className="form_container">
                <div className="header">
                    <div className="title">{location?.name}</div>
                    <div className="icons">
                        <ButtonCircle
                            icon="/assets/icons/close.svg"
                            iconHeight={15}
                            iconWidth={15}
                            onClick={onClose}
                        />
                    </div>
                </div>
                <div className="">
                    <div>Set points</div>
                    <div>......</div>
                    <div>Tabs</div>
                    <div>Body Cart</div>
                </div>
                <div className="floatIcons">
                    <img
                        src="/assets/icons/chatsIcon.svg"
                        alt="analyst"
                        width={30}
                        height={30}
                    />
                </div>
            </div>
        </div>
    );
};
